<template>
  <component :is="componentName" v-bind="card" :certificateStatus="certificateStatus"></component>
</template>

<script>
  import ProductInformation from './modules/ProductInformation.vue'
  import AuthenticationInformation from './modules/AuthenticationInformation.vue'
  import SupplierInformation from '@views/general/modules/SupplierInformation.vue'
  import OurStory from './modules/OurStory.vue'
  import WayInformation from '@views/general/modules/WayInformation.vue'
  import OriginDescription from '@views/general/modules/OriginDescription.vue'
  import QualityCommitment from '@views/general/modules/QualityCommitment.vue'
  import CompensationCommitment from './modules/CompensationCommitment'
  import WorkInformation from './modules/WorkInformation.vue'
  import InspectionLink from './modules/InspectionLink.vue'
  import LogisticsDistribution from './modules/LogisticsDistribution.vue'
  import VideoDescription from '@views/general/modules/VideoDescription.vue'
  import ProductPromotion from '@views/general/modules/ProductPromotion.vue'
  import SciencePopularization from './modules/SciencePopularization.vue'
  import { getComponentNameByCardTypeEnums } from '@/enums/CardTypeEnums'
  import CustomComponent from '@views/general/customcomponent/CustomComponent.vue'


  export default {
    name: 'CardItem',
    props: {
      card: {
        type: Object,
        default: () => ({})
      },
      certificateStatus: {
        type: String,
        default: ''
      }
    },
    components: {
      CustomComponent,
      ProductPromotion,
      SciencePopularization,
      VideoDescription,
      LogisticsDistribution,
      InspectionLink,
      WorkInformation,
      CompensationCommitment,
      OriginDescription,
      AuthenticationInformation,
      ProductInformation,
      SupplierInformation,
      WayInformation,
      OurStory,
      QualityCommitment
    },
    data() {
      return {}
    },
    computed: {
      componentName() {
        // return getComponentNameByCardTypeEnums(this.card.cardType)
        // 现在全部设为自定义组件
        return 'CustomComponent'
      }
    },
    methods: {
      initData() {
      },
      loadData() {
      }
    }
  }
</script>

<style lang="less" scoped>
</style>
